import { render } from "./SwiperSlide.vue?vue&type=template&id=556c40ca"
import script from "./SwiperSlide.vue?vue&type=script&lang=js"
export * from "./SwiperSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__